<div class="container">
  <div class="label-container">
    <div
      b2cSvg
      width="90px"
      class="bubble"
      id="selection-button-variant-3"
      [svgPath]="config().catchPhrase.imageUrl"
      [fill]="config().catchPhrase.amountBackgroundColor"
      [alt]="config().catchPhrase.alternativeText | replaceVars: maxReward()"
    ></div>

    <div
      class="catchphrase-container"
      [style.--catchphrase-bg]="config().catchPhrase.amountBackgroundColor"
    >
      @let reward = maxReward() | formatReward;
      <p>{{ config().catchPhrase.amountLabel }}</p>
      <div
        class="amount"
        [innerHTML]="reward | safe"
        [style.lineHeight]="config().catchPhrase.lineHeight"
      ></div>
    </div>
  </div>
  <b2c-button
    [styles]="{
      color: 'white',
      fontSize: '13px',
      width: selectionInProgress() ? '100px' : '265px',
      borderRadius: config().buttonCatchPhrase.borderRadius,
      fontFamily: config().buttonCatchPhrase.buttonAmountFontFamily,
      borderColor: config().buttonCatchPhrase.buttonAmountBackgroundColor,
      backgroundColor: config().buttonCatchPhrase.buttonAmountBackgroundColor,
    }"
    data-cy="select_btn"
    [loading]="selectionInProgress()"
    [title]="config().buttonCatchPhrase.buttonAmountLabel"
    (click)="
      selectChallenge(challenge(), phase(), isBisCampaign(), isEventChallenge())
    "
    [disabled]="
      challenge().isOutOfStock() ||
      selectionInProgress() ||
      blockSelectionButton()
    "
  >
    {{ config().buttonCatchPhrase.buttonAmountLabel }}
  </b2c-button>
</div>
